import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { App } from "./App";
import { store } from './_helpers';
import {socketService} from "./_services/socket";

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('app')
// );

class MyComponent extends React.Component {
	componentDidMount(){
		console.log("in a indexjs ------------------------------");
		socketService.initializeSocketListener();
	}
	render(){
		return (
			<Provider store={store}>
        		<App />
    		</Provider>
		);
	}
}

ReactDOM.render(<MyComponent />,document.getElementById('app'));